exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#change-user-trial .modal-body .form-group label[data-v-5744c448]{margin-bottom:1px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5744c448","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/pages/admin/index/ChangeSubscriptionTrial.vue
// module id = 1116
// module chunks = 0